export default __webpack_public_path__ + "static/media/151-bridges.60cc62d7.png";